export const textVariant = (delay) => {
  return {
    hidden: {
      y: -50,
      opacity: 0, // Ensure opacity is 0 when hidden
    },
    show: {
      y: 0,
      opacity: 1, // Make text fully visible when shown
      transition: {
        type: "spring",
        duration: 1.25,
        delay: delay,
      },
    },
  };
};

export const fadeIn = (direction, type, delay, duration) => {
  return {
    hidden: {
      x: direction === "left" ? 100 : direction === "right" ? -100 : 0,
      y: direction === "up" ? 100 : direction === "down" ? -100 : 0,
      opacity: 0, // Ensure opacity is 0 when hidden
    },
    show: {
      x: 0,
      y: 0,
      opacity: 1, // Make fully visible when shown
      transition: {
        type: type,
        delay: delay,
        duration: duration,
        ease: "easeOut",
      },
    },
  };
};

export const zoomIn = (delay, duration) => {
  return {
    hidden: {
      scale: 0,
      opacity: 0, // Ensure opacity is 0 when hidden
    },
    show: {
      scale: 1,
      opacity: 1, // Make fully visible when shown
      transition: {
        type: "tween",
        delay: delay,
        duration: duration,
        ease: "easeOut",
      },
    },
  };
};

export const slideIn = (direction, type, delay, duration) => {
  return {
    hidden: {
      x: direction === "left" ? "-100%" : direction === "right" ? "100%" : 0,
      y: direction === "up" ? "100%" : direction === "down" ? "100%" : 0,
      opacity: 0, // Ensure opacity is 0 when hidden
    },
    show: {
      x: 0,
      y: 0,
      opacity: 1, // Make fully visible when shown
      transition: {
        type: type,
        delay: delay,
        duration: duration,
        ease: "easeOut",
      },
    },
  };
};

export const staggerContainer = (staggerChildren, delayChildren) => {
  return {
    hidden: {
      opacity: 0, // Ensure opacity is 0 when hidden
    },
    show: {
      opacity: 1, // Make fully visible when shown
      transition: {
        staggerChildren: staggerChildren,
        delayChildren: delayChildren || 0,
      },
    },
  };
};
